// React
import React from 'react'

// eslint-disable-next-line import/prefer-default-export
import {
  CopyId,
  LinkedInShare,
  MailShare,
  PrintShare,
  TwitterShare,
  FacebookShare
} from '.'

export type SocialProps = {
  copyText: string
  report?: boolean
  root: string
  title: string
  url: string
}

// eslint-disable-next-line import/prefer-default-export
export const Social = ({ copyText, report, root, title, url }: SocialProps) => {
  const encodeTitle = encodeURIComponent(title)
  const resolveUrl = (url: string) => {
    const s = url
    return s.startsWith('/') ? s.replace('/', '') : s
  }
  const encodeUrl = encodeURIComponent(`${root}/${resolveUrl(url)}`)

  return (
    <div className="social-icons">
      <FacebookShare url={encodeUrl} title={encodeTitle} />

      <TwitterShare status={encodeTitle} url={encodeUrl} />

      <LinkedInShare title={encodeTitle} url={encodeUrl} />

      <MailShare body={encodeUrl} subject={encodeTitle} />

      {!report && <PrintShare url="#" />}

      {copyText && <CopyId copyText={copyText} />}
    </div>
  )
}
